import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {

    path: string;
    TOKEN_KEY = 'token';

    private authObservable: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(private http: HttpClient, private injector: Injector) { }

    public get router(): Router {
        return this.injector.get(Router);
    }

    get token() {
        return localStorage.getItem(this.TOKEN_KEY);
    }

    get isAuthenticated() {
        return !!localStorage.getItem(this.TOKEN_KEY);
    }

    login = (uri: string, session: string, type: string) => {
        this.logout();
        const data = {
            SessionId: session,
            Instance: uri
        };
        const promise = new Promise((resolve, reject) => {
            this.http.post(`api/auth/token`, data).subscribe((res: any) => {
                this.saveToken(res.token);
                this.router.navigate(['/' + type]);
                resolve();
            }, err => {
                reject(err);
            });
        });
        return promise;
    }

    localPromise = (type: string) => {
        this.logout();
        const promise = new Promise((resolve, reject) => {
            this.http.get('api/auth/local').subscribe((res: any) => {
                this.saveToken(res.token);
                this.router.navigate(['/' + type]);
                resolve();
            }, err => {
                reject(err);
            });
        });
        return promise;
    }

    logout = () => {
        this.authObservable.next(false);
        localStorage.removeItem(this.TOKEN_KEY);
    }

    saveToken(token) {
        localStorage.setItem(this.TOKEN_KEY, token);
    }

}
